export default function TS_Type_Guards() {
  return (
    <div>
      <h1>TS Type Guards</h1>
      <p>This is the TS Type Guards page.</p>
    </div>
  );
}